<template>
  <div class="row padd-0">
    <div class="col-12 padd-0">
      <div class="row">
        <div class="col-12 padd-0">
          <b-form-input
            v-model="value.name"
            :state="errAllow ? nameOk : null"
            placeholder="Full Name"
            class="mb-3"
            required
          ></b-form-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 padd-0">
          <b-input
            v-model="value.email"
            placeholder="Email"
            class="mb-3"
            :state="errAllow ? emailOk : null"
          ></b-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 padd-0">
          <b-form-select
            v-model="value.role"
            :options="rolePool"
            :state="errAllow ? roleOk : null"
            class="mb-3"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Choose user role --</b-form-select-option>
            </template>
          </b-form-select>
        </div>
      </div>
      <div class="row" v-if="errAllow && (!nameOk || !emailOk || !roleOk)">
        <div class="col-12 padd-0" style="color: darkred">
          <p class="mb--0" v-if="!nameOk">Name is required and should be at least 3 chars long</p>
          <p
            class="mb--0"
            v-if="!emailOk"
          >{{isNew && alladmins.find(el => el.email == value.email) ? 'User with this email already exists' : 'Email is required'}}</p>
          <p class="mb--0" v-if="!roleOk">Select user role, please</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSettingForm",
  props: {
    value: Object,
    rolePool: Array,
    alladmins: Array,
    errAllow: Boolean,
    isNew: Boolean
  },
  data() {
    return {
      admin: {
        name: "",
        email: "",
        role: null
      },
      err: ""
    };
  },
  computed: {
    formOk() {
      return (
        this.val(this.nameOk) && this.val(this.emailOk) && this.val(this.roleOk)
      );
    },
    nameOk() {
      return this.value.name != "" && this.value.name.length > 3;
    },
    emailOk() {
      return (
        this.value.email.length > 5 &&
        this.value.email.includes("@") &&
        (this.isNew
          ? !this.alladmins.find(el => el.email == this.value.email)
          : true)
      );
    },
    roleOk() {
      return this.val(this.value.role);
    }
  },
  watch: {
    formOk: function(v) {
      this.$emit("setOk", v);
    }
  },
  mounted() {
    this.$emit("setOk", this.formOk);
  },
  methods: {
    val(d) {
      return d != undefined && d != null && d != "";
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.mb--0 {
  margin-bottom: 0;
}
</style>




